//
// UploadAvatarPanel
//
// drop an image to update the avatar

import { observer } from 'mobx-react-lite'
import React, { useRef, useState } from 'react'
import { useDrop } from 'react-dnd'
import { NativeTypes } from 'react-dnd-html5-backend'
import { useStore } from '../stores'

import { Avatar } from '.'
import { ValidationMessage } from '../components'
import { ImageFileTypes } from '../utils/filetypes'
import { VALIDATION, ValidationResult } from '../utils/validation'

export const UploadAvatarPanel = observer(
    React.forwardRef(function UploadAvatarPanel({ user, ...other }, ref) {
        const { data } = useStore()

        const avatarRef = useRef(null)

        const [dropvalidation, setDropvalidation] = useState(null)

        const canDrop = dragitem => {
            if (!ref.current || !dragitem) {
                return false
            }
            if (dragitem.hasOwnProperty('files')) {
                return true
            }
            return false
        }

        const [{ isOver }, drop] = useDrop({
            accept: NativeTypes.FILE,
            canDrop: dragitem => canDrop(dragitem),
            collect: monitor => {
                const isOver = !!monitor.isOver()
                return {
                    isOver: isOver,
                }
            },
            drop: (item, monitor) => {
                const droppedfile = item.files[0]
                if (droppedfile.size && ImageFileTypes.includes(droppedfile.type)) {
                    setDropvalidation(
                        new ValidationResult(VALIDATION.REPORT, 'Uploading...')
                    )
                    return data.actions
                        .upload_avatar(droppedfile)
                        .then(usergid => {
                            setDropvalidation(
                                new ValidationResult(
                                    VALIDATION.SUCCESS,
                                    'Avatar updated'
                                )
                            )
                            window.setTimeout(
                                () =>
                                    setDropvalidation(
                                        new ValidationResult(VALIDATION.NA)
                                    ),
                                500
                            )
                            return usergid
                        })
                        .catch(() => {
                            setDropvalidation(
                                new ValidationResult(VALIDATION.ERROR, 'Upload failed')
                            )
                            window.setTimeout(
                                () =>
                                    setDropvalidation(
                                        new ValidationResult(VALIDATION.NA)
                                    ),
                                1500
                            )
                        })
                } else {
                    setDropvalidation(
                        new ValidationResult(VALIDATION.ERROR, 'Unsupported type')
                    )
                    window.setTimeout(
                        () => setDropvalidation(new ValidationResult(VALIDATION.NA)),
                        1500
                    )
                }
            },
        })

        drop(avatarRef)

        let dropclassname = 'avatar-upload'
        if (isOver) dropclassname += ' drag-over-inside'

        return (
            <div className={dropclassname}>
                <Avatar
                    user={user}
                    ref={node => {
                        if (ref) ref.current = node
                        if (avatarRef) avatarRef.current = node
                    }}
                    {...other}
                />
                {dropvalidation ? (
                    <ValidationMessage validation={dropvalidation} />
                ) : undefined}
            </div>
        )
    })
)
